import { extractFieldKeyFromSelector } from '../utils';

const SOURCE_VAR_PATTERN =
  /var\s+(\w+)\s*=\s*removeCurrencyFormat\(\s*\$\(\s*["']([^"']*\[id\^=[^"']*\])["']\s*\)\.val\(\)\s*\)/g;

const WRITE_SUM_PATTERN =
  /\$\(\s*["']([^"']*\[id\^=[^"']*\])["']\s*\)\.val\(\s*currencyFormatter\(\s*([\w\s+]+?)\s*\)\s*\)/;

export function detectComputedSum(script, ownerFieldKey) {
  if (!script) return null;

  const sourceVars = {};
  let match;
  SOURCE_VAR_PATTERN.lastIndex = 0;
  while ((match = SOURCE_VAR_PATTERN.exec(script)) !== null) {
    const fieldKey = extractFieldKeyFromSelector(match[2]);
    if (fieldKey) sourceVars[match[1]] = fieldKey;
  }

  if (Object.keys(sourceVars).length < 2) return null;

  const writeMatch = WRITE_SUM_PATTERN.exec(script);
  if (!writeMatch) return null;

  const targetFieldKey = extractFieldKeyFromSelector(writeMatch[1]);
  if (!targetFieldKey) return null;

  const sources = writeMatch[2]
    .split('+')
    .map(v => v.trim())
    .map(v => sourceVars[v])
    .filter(Boolean);

  if (sources.length < 2) return null;

  const ownerBase = String(ownerFieldKey ?? '').replace(/_[a-f0-9]{6,}$/i, '');
  const targetBase = targetFieldKey.replace(/\*$/, '');
  const target = targetBase === ownerBase ? 'self' : targetFieldKey;

  return {
    when: { always: true },
    actions: [{ action: 'setValue', target, sources, decimalPlaces: 2 }],
  };
}
